import { create } from 'zustand';

export type TabSheetBenefits =
  | 'guia_de_assistencias'
  | 'guia_de_coberturas'
  | 'condicoes_gerais'
  | 'guia_de_nao_cobre';

type SheetStoreProps = {
  openSheetBenefits: boolean;
  openSheetCondition: boolean;
  openSheetPartners: boolean;
  openSheetQrCodeIndex?: number;
  openSheetEsgDescription: boolean;
  sheetTabSelected: TabSheetBenefits;
  setOpenSheetBenefits: (open: boolean) => void;
  setOpenSheetCondition: (open: boolean) => void;
  setOpenSheetPartners: (open: boolean) => void;
  setOpenSheetQrCodeIndex: (index?: number) => void;
  setOpenEsgDescription: (open: boolean) => void;
  setSheetTabSelected: (option: TabSheetBenefits) => void;
};

export const sheetStore = create<SheetStoreProps>((set) => ({
  openSheetBenefits: false,
  openSheetCondition: false,
  openSheetPartners: false,
  sheetTabSelected: 'guia_de_assistencias',
  openSheetEsgDescription: false,
  setOpenSheetBenefits: (open: boolean) => set({ openSheetBenefits: open }),
  setOpenSheetCondition: (open: boolean) => set({ openSheetCondition: open }),
  setOpenSheetQrCodeIndex: (index?: number) => set({ openSheetQrCodeIndex: index }),
  setSheetTabSelected: (option: TabSheetBenefits) => set({ sheetTabSelected: option }),
  setOpenSheetPartners: (open: boolean) => set({ openSheetPartners: open }),
  setOpenEsgDescription: (open: boolean) => set({ openSheetEsgDescription: open })
}));
